import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { FaCalendarAlt, FaUserAlt, FaFolderOpen } from "react-icons/fa";
import AutoScallingyad2taxiforsale from "../../components/AutoScallingyad2taxiforsale/AutoScallingyad2taxiforsale";
import NewTaxisHomePageCards from "../../components/NewTaxisHomePageCards/NewTaxisHomePageCards";
import { FaHandPointer } from "react-icons/fa";
import "./BlogsTemplatePage.css";
import InsuranceSummaryHomepage from "../../components/InsuranceSummaryHomepage/InsuranceSummaryHomepage";
import ContactInsuranceForm from "../InsuranceTaxiPage/ContactInsuranceForm";
import BuyNewTaxiSiderHomePage from "../../components/BuyNewTaxiSiderHomePage/BuyNewTaxiSiderHomePage";
import ArticlesPreview from "../../components/ArticlesPreviewBlog/ArticlesPreviewBlog";
import MiniProductsCarouselHome from "../../components/MiniProductsCarouselHome/MiniProductsCarouselHome";

const BlogsTemplatePage = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(`/api/taxiblogs/${id}`);
        setBlog(response.data);
      } catch (error) {
        console.error("❌ שגיאה בטעינת המאמר:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  if (loading) {
    return <div className="BlogsTemplatePage__loading">טוען מאמר...</div>;
  }

  if (!blog) {
    return <div className="BlogsTemplatePage__error">❌ המאמר לא נמצא</div>;
  }

  // ✅ אחרי שיש Blog - נבנה את הכתובות
  const imageUrl = `/public/uploads/TaxiBlogsImg/${blog.id}.webp`;
  const pageUrl = `/blog/${blog.id}`;

  return (
    <>
      {/* SEO מקצועי */}
      <Helmet>
        <title>{blog.seo_title || blog.title}</title>
        {blog.seo_description && (
          <meta name="description" content={blog.seo_description} />
        )}
        {/* Open Graph */}
        <meta property="og:title" content={blog.seo_title || blog.title} />
        {blog.seo_description && (
          <meta property="og:description" content={blog.seo_description} />
        )}
        <meta property="og:image" content={imageUrl} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:type" content="article" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blog.seo_title || blog.title} />
        {blog.seo_description && (
          <meta name="twitter:description" content={blog.seo_description} />
        )}
        <meta name="twitter:image" content={imageUrl} />

        {/* Keywords (אם יש) */}
        {blog.keywords && (
          <meta name="keywords" content={blog.keywords} />
        )}

        {/* Canonical URL */}
        <link rel="canonical" href={pageUrl} />
      </Helmet>

      {/* תוכן העמוד */}
      <motion.div
        className="BlogsTemplatePage-container"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="blog-title-gradient">{blog.title}</h1>

        {blog.summary && (
          <p className="blog-summary">{blog.summary}</p>
        )}

        <div className="blog-image-wrapper">
          <img
            className="blog-image"
            src={imageUrl}
            alt={blog.alt_text || blog.title}
          />
        </div>

<div className="blog-content">
  {blog.content.split('\n').map((line, index) => (
    <p key={index}>{line}</p>
  ))}
</div>



        <div className="blog-footer">
          {blog.category && (
            <span className="footer-item">
              <FaFolderOpen /> {blog.category}
            </span>
          )}
          {blog.author && (
            <span className="footer-item">
              <FaUserAlt /> {blog.author}
            </span>
          )}
          {blog.created_at && (
            <span className="footer-item">
              <FaCalendarAlt /> {new Date(blog.created_at).toLocaleDateString("he-IL")}
            </span>
          )}
        </div>
        <p className="TaxiInsuranceAIDisclaimer">
  🧠 שים לב: מאמר זה נכתב בעזרת בינה מלאכותית (AI) והוא למטרות מידע בלבד. תמיד מומלץ להתייעץ עם סוכן ביטוח מוסמך לפני קבלת החלטות.
</p>
  <div className="AutoScallingyad2taxiforsaleh4">
      <h2>מגוון מוניות יד 2 מחכות רק לך!</h2>
    </div>
  <div className="AutoScallingIconsHomepage">
      <AutoScallingyad2taxiforsale />
    </div>
    <div className="swipe-hint mobile-only">
  <FaHandPointer className="swipe-icon" />
  <span className="swipe-text">דפדף ימינה</span>
</div>
<div className="NewTaxisHomePageCardsAtPageDiv2">
  <NewTaxisHomePageCards />
  <button className="hero-button-InsurancePage" onClick={() => window.location.href = '/AllTaxiYad2ForSalepage'}>למאגר המוניות</button>
</div>
<div className="ProductsBlogSinaglePage">
  <MiniProductsCarouselHome />
</div>
<div className="InsurancePageCarouselSectionBlogsPage">
  <InsuranceSummaryHomepage />
</div>
<div className="InsurancePageContactSection">
  <h2 className='InsuranceTaxiContactPageTitle'>השאר פרטים ונציג יחזור אלייך בהקדם</h2>
  <ContactInsuranceForm />
</div>
<div className="BuyNewTaxiSiderHomePageBlogPage">
  <BuyNewTaxiSiderHomePage />
</div>
<div className="ArticlesPreviewHomePage">
  <ArticlesPreview />
</div>
      </motion.div>
    </>
  );
};

export default BlogsTemplatePage;
